module.exports = { "default": require("core-js/library/fn/object/define-properties"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/~/babel-runtime/core-js/object/define-properties.js
// module id = 94
// module chunks = 1